import axios from 'axios';
import notify from '@/store/Common/notify';

export default function cacheGoogleFonts() {
    return new Promise((resolve, reject) => {
        // Retrieve font list from the Google API.
        fetch('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyDj8Z0Gq2tTKH7uL__1KXZ18KW8IRFyn54')
            .then((response) => response.json())


            .then(response => {
                // Handle errors and reject.
                if (response.error) {
                    console.error(response.error.message);
                    if(response.error.errors) {
                        response.error.errors.forEach(error => {
                            if (error.message) {
                                console.error(error.message);
                            }
                        });
                    }
                    reject();
                    return;
                }

                if (!response.items) {
                    console.error('Google Font API returned no data.');
                    reject();
                    return;
                }

                // Success, send the font list to our API for storage.
                const data = {
                    fonts: response.items
                };

                axios.post('/api/font-pairing/cache', data)
                    .then(() => {
                        notify('Google Fonts successfully cached.', 'success');
                        resolve();
                    });
            })
            .catch(() => {
                reject();
            });
    });
}
